import { useDisclosure } from '@chakra-ui/react'
import { MdSearch } from 'react-icons/md'
import { WhatNextCommonUI } from './whatNextCommonUI'
import { useQuery } from 'react-query'
import { searchOrgContactsQueryKey } from '../../utils/queryKeyFactory'
import React from 'react'
import {
	searchOrgContactsQuery,
	useLoadActivityDetails,
} from '../../hooks/activity.hooks'
import { useLanguageContext } from '../../context/locale.context'
import { WhatNextDelegateSearch } from './whatNextDelegateSearch'
import { useInviteParticipant } from './../../hooks/activity.hooks'
import { useSharedContext } from './../../context/shared.context'
import { useAuthContext } from './../../context/auth.context'
import { sharedConst } from '../../utils/action.constant'

const WhatNextDelegate = () => {
	const {
		state: { locale },
	} = useLanguageContext()

	const {
		state: { activity },
		dispatch,
	} = useSharedContext()

	const {
		state: { authData },
	} = useAuthContext()

	const { asset_id, asset_flag_super_admin } = authData

	const { isOpen, onOpen, onClose } = useDisclosure()

	const searchOrgContactsParam = {
		limit_value: 3,
	}
	const buttonsList = []

	const { mutate: inviteMutate } = useInviteParticipant()
	const { mutate: mutateLoadActivity } = useLoadActivityDetails()

	const { data: orgContactsData } = useQuery(
		searchOrgContactsQueryKey.search_string_param(searchOrgContactsParam),
		() => searchOrgContactsQuery(searchOrgContactsParam)
	)

	const { activity_id, activity_type_category_id, activity_type_id } = activity

	const loadDetails = () => {
		mutateLoadActivity(
			{
				activity_id: activity.activity_id,
				activity_type_id: activity.activity_type_id,
			},
			{
				onSuccess: async details => {
					const isLead = asset_id === details.activity_lead_asset_id
					const isOwner = asset_flag_super_admin
					dispatch({
						type: sharedConst.ACTVITY_SELECTED,
						payload: {
							...details,
							isLead,
							isOwner,
						},
					})
				},
				onError: async err => {
					console.log('Err occurred', err)
				},
			}
		)
	}

	const delegateToUser = user => {
		inviteMutate(
			{
				activity_id,
				activity_type_category_id,
				activity_type_id,
				add_as_lead: 1,
				from_user_interface: 1,
				contact: {
					asset_type_id: user.asset_type_id,
					asset_id: user.asset_id,
					asset_first_name: user.asset_first_name,
					operating_asset_first_name: user.operating_asset_first_name,
					workforce_name: user.workforce_name,
				},
			},
			{
				onSuccess: data => {
					loadDetails(activity)
					dispatch({
						type: sharedConst.HANDLE_WHATSNEXT,
						payload: false,
					})
					setTimeout(() => {
						dispatch({
							type: sharedConst.REFRESH_LISTING,
						})
					}, 1000)
				},
			}
		)
	}

	orgContactsData &&
		orgContactsData.slice(0, 3).forEach((contact, index) => {
			buttonsList.push({
				label: contact.contact_operating_asset_name,
				action: () => {
					delegateToUser(contact)
				},
			})
			if (index === 2)
				buttonsList.push({
					label: locale['Search'],
					action: () => {
						onOpen()
					},
				})
		})

	return (
		<>
			<WhatNextCommonUI
				headerText={locale['Whom do you want to delegate?']}
				buttonsList={buttonsList}
			/>
			<WhatNextDelegateSearch
				isOpen={isOpen}
				onClose={onClose}
				delegateToUser={delegateToUser}
			/>
		</>
	)
}

export { WhatNextDelegate }
